import { Col } from "antd";

export default function FormCol({
  children,
  size = "md",
}: {
  children: React.ReactNode;
  size?: "xs" | "md" | "lg" | "xl";
}) {
  switch (size) {
    case "xs":
      return (
        <Col xs={24} sm={24} md={8} lg={6} xl={6}>
          {children}
        </Col>
      );
    case "md":
      return (
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          {children}
        </Col>
      );
    case "lg":
      return (
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          {children}
        </Col>
      );
    case "xl":
      return (
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          {children}
        </Col>
      );
  }
}
